module.exports = __webpack_public_path__ + "img/13.43e8462d.jpg";